// extracted by mini-css-extract-plugin
export default {"img":"NxgzBS","link":"J7HHSr"};